import { computed, onMounted, onUnmounted, readonly, ref, type Ref } from 'vue'

export const useCountdown = (from: number): Ref<number> => {
  if (from <= 0) {
    return computed(() => 0)
  }
  const count = ref(from)
  const intervalId = ref<NodeJS.Timeout | null>(null)
  onMounted(() => {
    intervalId.value = setInterval(() => {
      count.value--
      if (count.value <= 0 && intervalId.value !== null) {
        clearInterval(intervalId.value)
      }
    }, 1000)
  })

  onUnmounted(() => {
    if (intervalId.value !== null) {
      clearInterval(intervalId.value)
    }
  })
  return readonly(count)
}
